import { tv } from '@costar-ui/cosmos';
import React, { useMemo } from 'react';
import Spinner from '../spinner/spinner.esm.js';
import '../spinner/types.esm.js';
import Text from '../text/text.esm.js';
import '../text/heading.esm.js';
import '../text/text-container.esm.js';

var contentWrapperTV = tv({
  variants: {
    orientation: {
      vertical: 'flex flex-col items-center',
      horizontal: ''
    },
    hasGap: {
      "true": 'gap-1'
    },
    isLoading: {
      "true": 'invisible'
    }
  }
});
function WaitLayout(_ref) {
  var isLoading = _ref.isLoading,
    size = _ref.size,
    orientation = _ref.orientation,
    iconBefore = _ref.iconBefore,
    iconAfter = _ref.iconAfter,
    textSize = _ref.textSize,
    text = _ref.text;
  var loading = useMemo(function () {
    var spinnerSize = size !== null && size !== void 0 && size.endsWith('sm') ? 'sm' : 'md';
    return isLoading && /*#__PURE__*/React.createElement("div", {
      className: "absolute inset-0 flex items-center justify-center text-inherit"
    }, /*#__PURE__*/React.createElement(Spinner, {
      size: spinnerSize
    }));
  }, [isLoading, size]);
  return orientation === 'vertical' ? /*#__PURE__*/React.createElement(React.Fragment, null, loading, /*#__PURE__*/React.createElement("div", {
    className: contentWrapperTV({
      orientation: orientation,
      isLoading: isLoading,
      hasGap: !!text
    })
  }, iconBefore, text && /*#__PURE__*/React.createElement(Text, {
    size: textSize || '0.75'
  }, text), iconAfter)) : /*#__PURE__*/React.createElement(React.Fragment, null, loading, iconBefore, text && /*#__PURE__*/React.createElement(Text, {
    className: contentWrapperTV({
      orientation: orientation,
      isLoading: isLoading,
      hasGap: !!text
    })
  }, text), iconAfter);
}

export { WaitLayout as default };
//# sourceMappingURL=wait-layout.esm.js.map
